import React, { useState } from 'react';
import { FaUser, FaLock, FaEye, FaEyeSlash } from 'react-icons/fa';
import { FaEnvelope } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { postData } from '../../../webService/webservice.js'; // Adjust path as needed
import { toast } from 'react-toastify';
import '../../../styles/Auth/login.css';

const LoginPage = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            // postData already throws if not OK
            const result = await postData("users/signin", { email, password });

            // unwrap the backend response
            const userData = result?.data;
            if (!userData?.sessionToken) {
                throw new Error("No session token received.");
            }

            // Save session info
            sessionStorage.setItem("sessionToken", userData.sessionToken);
            sessionStorage.setItem("userId", userData.userId);
            sessionStorage.setItem("userName", userData.name);
            sessionStorage.setItem("role", userData.role);
            // Role-specific handling
            if (userData.role === "Admin" || userData.role === "SuperAdmin") {
                navigate("/dashboard");
                sessionStorage.getItem("sessionToken");
            } else if (userData.role === "Biller") {
                navigate("/pos");
                sessionStorage.getItem("sessionToken");
            }
            else {
                toast.error('Invalid credentials or no token received.');
            }

            toast.success("Login successful!");
        } catch (error) {
            console.error("Login Error:", error);
            toast.error(error.message || "Login failed.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className='login-bg'>
            <div className='login-container'>
                <div className='login-left'>
                    <img
                        src="/assets/mayura-logo.png"
                        alt='login'
                    />
                </div>
                <div className='login-right'>
                    <form className='login-form' onSubmit={handleLogin}>
                        <div className='login-logo'>

                            <img className='logo'
                                src="/assets/mayura.png"
                                alt='login'
                            />

                            <p className='login-title'>sign in your account</p>
                        </div>
                        <div className='login-input-group'>
                            <FaEnvelope className='login-input-icon' />
                            <input
                                type='email'
                                placeholder='Enter your email Id'
                                required
                                className='login-input'
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                            />
                        </div>

                        <div className="login-input-group">
                            <FaLock className="login-input-icon" />
                            <input
                                type={showPassword ? 'text' : 'password'}
                                placeholder="Password"
                                className="login-input"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                required
                            />
                            <span className="login-show" onClick={() => setShowPassword(s => !s)}>
                                {showPassword ? <FaEyeSlash className="login-input-icon" /> : <FaEye className="login-input-icon" />}
                            </span>
                        </div>

                        <div className="login-row login-options">
                            <label className="login-checkbox-label">
                                <input
                                    type="checkbox"
                                    checked={rememberMe}
                                    onChange={e => setRememberMe(e.target.checked)}
                                    className="login-checkbox"
                                />
                                Remember me
                            </label>
                            <span
                                className="login-link"
                                onClick={() => navigate('/forgot-password')}
                            >
                                Forgot Password?
                            </span>
                        </div>
                        <div className='sign-button'>
                            <button
                                type="submit"
                                className="login-btn-main"
                                style={{}}
                                disabled={isLoading}
                            >
                                {isLoading ? 'Signing in...' : 'Sign in'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
